import __request__ from "routing/request";
export function createFromParser(rule) {
  return __request__("POST", "/system/pipelines/rule", rule, {}, {
    "Accept": ["application/json"]
  });
}
export function getAll() {
  return __request__("GET", "/system/pipelines/rule", null, {}, {
    "Accept": ["application/json"]
  });
}
export function metricsConfig() {
  return __request__("GET", "/system/pipelines/rule/config/metrics", null, {}, {
    "Accept": ["application/json"]
  });
}
export function updateMetricsConfig() {
  return __request__("PUT", "/system/pipelines/rule/config/metrics", null, {}, {
    "Accept": ["application/json"]
  });
}
export function functionDescriptors() {
  return __request__("GET", "/system/pipelines/rule/functions", null, {}, {
    "Accept": ["application/json"]
  });
}
export function getBulk(rules) {
  return __request__("POST", "/system/pipelines/rule/multiple", rules, {}, {
    "Accept": ["application/json"]
  });
}
export function getPage(sort = "title", page = 1, per_page = 50, query, order = "asc") {
  return __request__("GET", "/system/pipelines/rule/paginated", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
export function parse(rule) {
  return __request__("POST", "/system/pipelines/rule/parse", rule, {}, {
    "Accept": ["application/json"]
  });
}
export function rulebuilderConditions() {
  return __request__("GET", "/system/pipelines/rule/rulebuilder/conditions", null, {}, {
    "Accept": ["application/json"]
  });
}
export function rulebuilderFunctions() {
  return __request__("GET", "/system/pipelines/rule/rulebuilder/functions", null, {}, {
    "Accept": ["application/json"]
  });
}
export function simulate(request) {
  return __request__("POST", "/system/pipelines/rule/simulate", request, {}, {
    "Accept": ["application/json"]
  });
}
export function get(id) {
  return __request__("GET", `/system/pipelines/rule/${id}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function update(rule, id) {
  return __request__("PUT", `/system/pipelines/rule/${id}`, rule, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(id) {
  return __request__("DELETE", `/system/pipelines/rule/${id}`, null, {}, {
    "Accept": ["application/json"]
  });
}
